export default __webpack_public_path__ + "static/plexus-full-width-3-mobile-c4f2532327154698b7c108a04b51f9b0.webp";